"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordTaskManagementService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordTaskManagementService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordTaskManagementService.instance) {
      return CordTaskManagementService.instance;
    }
    super();
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordTaskManagementService.instance = this;
  }
  searchTasks(queryObj) {
    return this.post('graphQl/tasks/search', queryObj);
  }
  createTask(task) {
    return this.post('tasks', task);
  }
  updateTask(taskId, task) {
    return this.put(`tasks/${taskId}`, task);
  }
  updateTaskStatus(taskId, task) {
    return this.patch(`tasks/${taskId}/status`, task);
  }
  updateTaskLabel(taskId, task) {
    return this.patch(`tasks/${taskId}/label`, task);
  }
}
exports.CordTaskManagementService = CordTaskManagementService;
CordTaskManagementService.instance = null;
